const categorias = [
  { desc: "Ajustes" },
  { desc: "Descuentos" },
  { desc: "Gratificaciones" },
];

export default categorias;
